/* @jsxImportSource react */

import * as React from 'react';

const PriceUnitPrice = ({
  children,
  ...props
}: React.HTMLAttributes<Omit<HTMLSpanElement, 'className'>>) => (
  <span
    className="text-size-body3 text-color-text-darktransparent inline-flex grow-0 items-center justify-start [grid-area:e] empty:hidden"
    {...props}
  >
    {children}
  </span>
);

PriceUnitPrice.displayName = 'PriceUnitPrice';

export { PriceUnitPrice };
